import HelpIcon from './HelpIcon.svg';
import DownloadIcon from './DownloadIcon.svg';

export default {
  HelpIcon,
  DownloadIcon,
};
